"use client";

import { useMemo } from "react";
import ReactECharts from "echarts-for-react";
import {
  buildEntStructMatchingOption,
  type LigneMatchingEntStruct,
} from "@repo/ent-struct";

export type { LigneMatchingEntStruct } from "@repo/ent-struct";

type Props = {
  lignes: LigneMatchingEntStruct[];
  titre?: string;
  hauteur?: string;
};

/**
 * Radar de matching d'un entretien structuré — l'enveloppe React de
 * `buildEntStructMatchingOption` (`@repo/ent-struct`), que le rapport PDF
 * rend aussi côté serveur. La grammaire de la figure est documentée là-bas.
 */
export function EntStructMatchingChart({
  lignes,
  titre = "Couverture par compétence",
  hauteur = "clamp(380px, 55vw, 660px)",
}: Props) {
  const option = useMemo(
    () => buildEntStructMatchingOption(lignes, { titre }),
    [lignes, titre],
  );

  if (lignes.length === 0) {
    return (
      <p className="text-muted-foreground py-8 text-center text-sm">
        Aucune compétence évaluée dans cet entretien : rien à représenter.
      </p>
    );
  }

  return (
    <ReactECharts
      option={option}
      notMerge
      style={{ width: "100%", height: hauteur }}
    />
  );
}
